class HighlightedSpecs extends HTMLElement {
  constructor() {
    super();
    this.dots = this.querySelectorAll('[data-dot-id]');
    this.specs = this.querySelectorAll('[data-spec-id]');

    this.initDotHoverEffects();
    this.initSpecHoverEffects();
  }

  /**
   * Initialize hover effects for dots on the images
   * When hovering a dot, find and highlight the matching spec
   */
  initDotHoverEffects() {
    this.dots.forEach((dot) => {
      const dotId = dot.getAttribute('data-dot-id');

      // Add mouseenter event
      dot.addEventListener('mouseenter', () => {
        // Find matching spec and add active class
        this.specs.forEach((spec) => {
          const specId = spec.getAttribute('data-spec-id');
          if (specId === dotId) {
            spec.classList.add('active');

            // Add before styles to spec
            spec.style.backgroundColor = '#FFFFFF';
            spec.style.borderColor = '#D8DE60';
          }
        });
      });

      // Add mouseleave event
      dot.addEventListener('mouseleave', () => {
        // Find matching spec and remove active class
        this.specs.forEach((spec) => {
          const specId = spec.getAttribute('data-spec-id');
          if (specId === dotId) {
            spec.classList.remove('active');

            // Remove before styles form spec
            spec.style.backgroundColor = '';
            spec.style.borderColor = '';
          }
        });
      });
    });
  }

  /**
   * Initialize hover effects for specs in the grid
   * When hovering a spec, find and highlight the matching dot(s)
   */
  initSpecHoverEffects() {
    this.specs.forEach((spec) => {
      const specId = spec.getAttribute('data-spec-id');

      // Add mouseenter event
      spec.addEventListener('mouseenter', () => {
        // Find matching dots and add active class
        this.dots.forEach((dot) => {
          const dotId = dot.getAttribute('data-dot-id');
          if (dotId === specId) {
            dot.classList.add('active');
          }
        });
      });

      // Add mouseleave event
      spec.addEventListener('mouseleave', () => {
        // Find matching dots and remove active class
        this.dots.forEach((dot) => {
          const dotId = dot.getAttribute('data-dot-id');
          if (dotId === specId) {
            dot.classList.remove('active');
          }
        });
      });
    });
  }
}

customElements.define('highlighted-specs', HighlightedSpecs);
